import { render, staticRenderFns } from "./addFtpTemplate.vue?vue&type=template&id=17b8f10f&scoped=true"
import script from "./addFtpTemplate.vue?vue&type=script&lang=js"
export * from "./addFtpTemplate.vue?vue&type=script&lang=js"
import style0 from "./addFtpTemplate.vue?vue&type=style&index=0&id=17b8f10f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b8f10f",
  null
  
)

export default component.exports